// extracted by mini-css-extract-plugin
export default {"wrapper":"PageHeaderContent_wrapper__7r2su","link":"PageHeaderContent_link__tUwPp"};